import { Avatar, Badge } from '@mui/material';
import SelectedBadge from '../SelectedBadge/SelectedBadge';

export default function SelectedAvatar() {
  return (
    <Badge
      anchorOrigin={{
        vertical: 'bottom', horizontal: 'right',
      }}
      badgeContent={<SelectedBadge />}
      overlap="circular"
    >
      <Avatar />
    </Badge>
  );
}
